import * as VPAIDEvents from '../../Enum/VPAIDEvents';

export const CONFIGURATION = {
  UPDATED : 'configuration.updated'
};

export const UI = {
  CLICKED         : 'ui.clicked',
  SKIPPED         : 'ui.skipped',
  SHARED          : 'ui.shared',
  HOVERED         : 'ui.hovered',
  PLAYED          : 'ui.played'
};

export const MEDIA = {
  DURATION_CHANGE  : 'media.duration_change',
  TIME_UPDATE      : 'media.time_update',
  PLAY             : 'media.play',
  STARTED          : 'media.started',
  PAUSE            : 'media.pause',
  COMPLETE         : 'media.complete',
  MESSAGE_RECEIVED : 'media.received_message',
  MESSAGE_SENT     : 'media.message_sent',
  VOLUME_CHANGE    : 'media.volume_change'
};

export const HOST = {
  MESSAGE_SENT     : 'host.message_sent',
  MESSAGE_RECEIVED : 'host.message_received'
};

export const MEASUREMENT = {
  IMPRESSION              : 'measurement.impression',
  VIDEO_START             : 'measurement.video_start',
  FIRST_QUARTILE          : 'measurement.first_quartile',
  MIDPOINT                : 'measurement.midpoint',
  THIRD_QUARTILE          : 'measurement.third_quartile',
  VIDEO_COMPLETE          : 'measurement.video_complete',
  VIDEO_VIEW              : 'measurement.video_view',
  COMPLETE                : 'measurement.complete',
  SKIPPED                 : 'measurement.skipped',
  CLICKED                 : 'measurement.clicked',
  PAUSE                   : 'measurement.pause',
  RESUME                  : 'measurement.resume',
  MUTE                    : 'measurement.mute',
  UNMUTE                  : 'measurement.unmute',
  FULLSCREEN              : 'measurement.fullscreen',
  SHARED                  : 'measurement.shared',
  SKIP_ENABLED            : 'measurement.skip_enabled',
  ERROR                   : 'measurement.error',
  EVENT_LOGGED            : 'measurement.event_logged',
  LOG_PROGRESS            : 'measurement.log_progress',
  LOG_COMPLETE            : 'measurement.log_complete',
  VIEWABILITY_ACHIEVED    : 'measurement.viewability_achieved',
  VIEWABILITY_UNSUPPORTED : 'measurement.viewability_unsupported',
  SURVEY_COMPLETE         : 'measurement.survey_complete',
  SURVEY_INVALID          : 'measurement.survey_invalid'
};

export const APPLICATION = {
  ERROR        : 'application.error',
  ERROR_LOGGED : 'application.error_logged'
};

export const VIEWABILITY = {
  INITIALIZED : 'viewability.initialized',
  STARTED     : 'viewability.started',
  UNSUPPORTED : 'viewability.unsupported',
  SNAPSHOT    : 'viewability.snapshot',
  ACHIEVED    : 'viewability.achieved',
  VIEWABLE    : 'viewability.viewable'
};

export const VPAID = VPAIDEvents;


// WEBPACK FOOTER //
// ./src/Services/State/Events.js